module.exports = __webpack_public_path__ + "static/academie-528becabb0269c4733cb9edc9a0f94c5.jpg";